/* Willow Haven product page behaviours (scoped, dependency-free) */
(function () {
  "use strict";

  /* Accordions */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".wh-root .acc-trigger");
    if (!btn) return;
    var item = btn.closest(".acc-item");
    var open = item.classList.toggle("open");
    btn.setAttribute("aria-expanded", open ? "true" : "false");
  });

  /* Gallery thumbs */
  document.addEventListener("click", function (e) {
    var thumb = e.target.closest(".wh-root .thumb");
    if (!thumb) return;
    var root = thumb.closest(".wh-root");
    root.querySelectorAll(".thumb").forEach(function (t) { t.classList.remove("is-active"); });
    thumb.classList.add("is-active");
    var main = root.querySelector("[data-wh-gallery-main]");
    if (main && thumb.dataset.src) {
      main.src = thumb.dataset.src;
      if (thumb.dataset.alt !== undefined) main.alt = thumb.dataset.alt;
    }
  });

  /* Bundle tiers -> price display + hidden variant id */
  function selectBundle(label) {
    var root = label.closest(".wh-root");
    root.querySelectorAll(".bundle").forEach(function (b) { b.classList.remove("is-selected"); });
    label.classList.add("is-selected");
    var radio = label.querySelector("input[type=radio]");
    if (radio) radio.checked = true;
    var idInput = root.querySelector("[data-wh-variant-id]");
    if (idInput && label.dataset.id) idInput.value = label.dataset.id;
    var set = function (sel, val, hideIfEmpty) {
      root.querySelectorAll(sel).forEach(function (el) {
        el.textContent = val || "";
        if (hideIfEmpty) el.style.display = val ? "" : "none";
      });
    };
    set("[data-wh-price-now]", label.dataset.now);
    set("[data-wh-price-was]", label.dataset.was, true);
    set("[data-wh-price-save]", label.dataset.save, true);
    var atc = root.querySelector("[data-wh-atc]");
    if (atc) {
      atc.disabled = label.dataset.available === "false";
      var priceSpan = atc.querySelector("[data-wh-atc-price]");
      if (priceSpan) priceSpan.textContent = label.dataset.available === "false" ? "" : label.dataset.now;
      var labelSpan = atc.querySelector("[data-wh-atc-label]");
      if (labelSpan && label.dataset.available === "false") labelSpan.textContent = atc.dataset.soldOut || "Sold out";
      else if (labelSpan) labelSpan.textContent = atc.dataset.label || labelSpan.textContent;
    }
  }
  document.addEventListener("click", function (e) {
    var label = e.target.closest(".wh-root .bundle");
    if (label) selectBundle(label);
  });
  document.querySelectorAll(".wh-root .bundle input:checked").forEach(function (r) {
    selectBundle(r.closest(".bundle"));
  });

  /* Delivery estimate */
  document.querySelectorAll("[data-wh-delivery]").forEach(function (el) {
    var min = parseInt(el.dataset.minDays || "4", 10);
    var max = parseInt(el.dataset.maxDays || "8", 10);
    var fmt = function (d) { return d.toLocaleDateString(document.documentElement.lang || "en-US", { month: "short", day: "numeric" }); };
    var a = new Date(); a.setDate(a.getDate() + min);
    var b = new Date(); b.setDate(b.getDate() + max);
    el.textContent = fmt(a) + " \u2013 " + fmt(b);
  });

  /* Sticky mobile ATC */
  var sticky = document.querySelector(".wh-root.sticky-atc");
  var hero = document.querySelector(".wh-root.product-hero");
  if (sticky && hero && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle("show", !entries[0].isIntersecting);
    }, { rootMargin: "-80px 0px 0px 0px" }).observe(hero);
  }
})();
